import {
  List,
  Datagrid,
  TextField,
  DateField,
  BooleanField,
} from "react-admin";
import GroupButtons from "../../components/group-buttons";
import CustomFilterDefault from "../../filter/custom-filter-default";
import CustomListDefaultToolbar from "../../ui/custom-list-default-toolbar";
import CustomImageField from "../../components/custom-image-field";
import EnterpriseExporter from "../../exporter/enterprise-exporter";
import ButtonDetails from "../../ui/button-details";
import ButtonEdit from "../../ui/button-edit";

const EnterpriseList = (props) => (
  <List
    title="Empresas"
    sort={{ field: "id", order: "DESC" }}
    filters={CustomFilterDefault}
    exporter={EnterpriseExporter}
    actions={<CustomListDefaultToolbar />}>
    <Datagrid
      rowClick={false}
      bulkActionButtons={false}>
      <TextField source="id" sortable={false} />
      <CustomImageField source="image_logo" label="Logo" sortable={false} />
      <TextField source="register_number" label="CNPJ" sortable={false} />
      <TextField source="name" label="Nome" sortable={false} />
      <BooleanField source="active" label="Ativo" sortable={false} />
      <DateField source="created_at" locales="pt-BR" label="Criado em" sortable={false} showTime />
      <GroupButtons>
        <ButtonDetails />
        <ButtonEdit />
      </GroupButtons>
    </Datagrid>
  </List>
);

export default EnterpriseList;
